import {ChangeDetectorRef, Component, OnDestroy, OnInit} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {AuthState} from '@shared/state/auth/auth.state';
import {GetAllUsers, GetUserStats} from '@shared/state/user/user.actions';
import {GetReportsCount} from '@shared/state/report/report.actions';
import {GetUpdatedAt} from '@shared/state/vehicle/vehicle.actions';
import {GetAllMlInfo, GetMakeAndModelData, GetMlStats, GetSimulationsMetadata} from '@shared/state/ml/ml.actions';
import {Store} from '@ngxs/store';
import {Subject} from 'rxjs';
import {GetAlerts} from '@shared/state/alert/alert.actions';
import {getNested} from '@shared/helpers';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy {
  private ngUnsubscribe: Subject<void> = new Subject<void>();
  isCollapsed = false;
  isCheckedOnce = false;

  constructor(private cd: ChangeDetectorRef, private store: Store) {
  }

  ngOnInit() {
    this.store.select(AuthState.getUserData)
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((userData) => {
        if (getNested(userData, 'role') === 'superuser' && !this.isCheckedOnce) {
          this.isCheckedOnce = true;
          this.store.dispatch(new GetAllUsers());
          this.store.dispatch(new GetUserStats());
          this.store.dispatch(new GetReportsCount());
          this.store.dispatch(new GetUpdatedAt());
          this.store.dispatch(new GetMlStats());
          this.store.dispatch(new GetAllMlInfo());
          this.store.dispatch(new GetMakeAndModelData());
          this.store.dispatch(new GetSimulationsMetadata());
          this.store.dispatch(new GetAlerts());
        }
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
